import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";

export const selectAgentState = (state: RootState) => state.agentState;

export const selectAgentValue = createSelector(
  selectAgentState,
  (state) => state.agentValue,
);

export const selectAgentUid = createSelector(
  [selectAgentValue],
  (agent) => agent?.agent_object?.uid ?? "",
);

export const selectAgentLoading = createSelector(
  selectAgentState,
  (state) => state.isAgentLoading,
);
